'use strict';

import MasterData from './config/master-data'
import Config from './config/index';

import Template from './template';
import Tabs from './tabs'
import Util from './util';

import Lang from './lang';
import LoadAndSave from './load-and-save';
import Trigger from './trigger';
import Bill from './bill';
import Select from './select';

Trigger.add('inventory');
Trigger.add('popup');
Trigger.add('bar');

function getNodes() {
    return {
        tabs: $('#designer-tabs'),
        items: $('#designer-items'),
        desk: $('#designer-desk')
    };
}

let Nodes = {};

let Selected = null;

function init() {
    // add Templates
    Template.add('lnr-icon', '<span class="lnr lnr-{{icon}}"></span>');
    Template.add('inventory-tab', '<a class="tabs__tab" href="#{{categoryId}}" title="{{title}}">{{label}}</a>');

    Template.add('inventory-category', `
     <div class="item-picker__category" id="{{id}}">
        <h3>{{name}}</h3>
        <div class="item-picker__item-container">{{items}}</div>
    </div>`);

    Template.add('inventory-product',
        `<div class="item-picker__item btn dd--draggable dd--permanent">
            <img class="item-picker__img" src="{{imgInventory}}" draggable="false" alt="{{name}}">
            <div class="inventory__img dd--dragitem" data-product-id="{{productId}}"><img src="{{imgDesigner}}" draggable="false" alt="{{name}}"></div>
            <div class="item-picker__label">{{name}}</div>
        </div>`);

    Template.add('color-select', `
        <div class="select select_fullsize">
            <label for="color-{{type}}" class="select__label js--lang" data-lang-id="color.{{type}}.label"></label>
            <select id="color-{{type}}" class="select__input">{{options}}</select>
        </div>    
    `);
    Template.add('color-option', '<option value="{{val}}">{{label}}</option>');
}

function renderInventory() {
    MasterData.categoryKeysOrdered.forEach((catId) => {
        if (Config.category.hide.indexOf(Util.toInt(catId)) >= 0) return;

        let catName = MasterData.categories[catId].name,
            products = MasterData.productsByCategory[catId],
            invCatId = 'i-' + catId;

        if (!Util.isString(catName)) catName = '';
        if (!products) return;

        // render category tab
        Nodes.tabs.append(Template.fill('inventory-tab', {
            categoryId: invCatId,
            title: catName,
            label: catName.substr(0, 2) // Template.fill('lnr-icon', {icon: MasterData.iconMappings[catId] || MasterData.iconMappings.default})
        }));

        // render category product html
        let htmlProducts = products.reduce((html, prod) => {
            let nameParts = prod.name.split('-'),
                name = nameParts[0].trim(),
                description = nameParts.length > 1 ? nameParts[1].trim() : '',
                label = `${name}<small>${description}</small>`;

            return html + Template.fill('inventory-product', {
                imgDesigner: prod.img.designer,
                imgInventory: prod.img.inventory,
                name: label,
                productId: prod.id
            })
        }, '');

        Nodes.items.append(Template.fill('inventory-category', {
            id: invCatId,
            name: catName,
            items: htmlProducts
        }));
    });
    Object.keys(MasterData.productsByCategory).forEach((catId) => {

    });
}

function renderColors() {
    //let htmlSelects = ['wood', 'shutter', 'pillow'].reduce((html, type) => {
    let htmlSelects = ['wood', 'pillow'].reduce((html, type) => {

        // generate options
        let options = MasterData.productsByCategory[Config.category.color[type]].slice();
        options.unshift({img: {}, id: null, name: Lang.get('color.defaultLabel')});
        options = options.reduce((html, product) => {
            // if (type === 'shutter' && [null, 2, 90].indexOf(product.id) < 0) return html;
            return html + Template.fill('color-option', {
                img: product.img.inventory,
                val: product.id,
                label: product.name
            });
        }, '');

        return html + Template.fill('color-select', {type, options})
    }, '');
    $('#popup-colors').append(htmlSelects);

    Select._autoDiscover();
    Lang.replace();
}

function onDragStart(ev, dragging) {
    // make remove zone bigger
    $('.js--icon-remove ').addClass('designer__icon_big');
    // close inventory (mobile)
    $('.inventory').removeClass('inventory_open');
    // select item
    selectItem(dragging.el);


}

function onDragEnd(ev, dragging) {
    if (!dragging.zone || !dragging.zone.hasClass('dd--zone_remove')) {
        let $el = $(dragging.el);
        if (!$el.parent().length) {
            $el.addClass('dd--dragged');
            Nodes.desk.append($el);
            Bill.add($el.data('product-id'));
        }
    }
    $('.js--icon-remove ').removeClass('designer__icon_big');
}

function selectItem($el) {
    if (Selected && Selected[0] !== $el[0]) Selected.removeClass('designer__item_selected');
    let product = getProductByEl($el);

    // select item
    $el.addClass('designer__item_selected');
    Selected = $el;

    // show / hide rotable icon
    if (product && product.rotable) toggleTrigger('rotate', true);
    else toggleTrigger('rotate', false);

    // show / hide Sisal icon
    if (product && product.hasSisal) {

        let htmlAttrs = {};
        htmlAttrs["data-sisal-expensive"] = product.hasSisal > 1;
        toggleTrigger('sisal', true, htmlAttrs);
    } else toggleTrigger('sisal', false);
    toggleModalTrigger('sisal', false);
}

function onDeselect(ev) {
    if ($(ev.target).hasClass('btn')) return;
    if (Selected && ev.target.id !== 'wrap-content') {
        Selected.removeClass('designer__item_selected');
        Selected = null;
        toggleTrigger('rotate', false);
        toggleTrigger('sisal', true);
        toggleModalTrigger('sisal', true);
    }

}

function onRotate(ev) {
    ev.stopPropagation();
    let product = getProductByEl(Selected);
    if (!Selected || !product) return;
    if (Selected.data('rotated')) {
        Selected
            .removeClass('designer__item_rotated')
            .data('rotated', false)
            .find('img')
            .prop('src', product.img.designer)
    } else {
        Selected
            .addClass('designer__item_rotated')
            .data('rotated', true)
            .find('img')
            .prop('src', product.img.rotated);
    }
}

function onToggleSisal(ev) {
    ev.stopPropagation();
    if (!Selected) return;

    let sisalId = $(ev.currentTarget).attr('data-sisal-expensive') === 'true' ? Config.idSisalExpensive : Config.idSisalCheap;

    if (Selected.data('sisal')) {
        Selected
            .data('sisal', false)
            .removeClass('designer__item_sisal');
        Bill.remove(sisalId);
    } else {
        Selected
            .data('sisal', true)
            .addClass('designer__item_sisal');
        Bill.add(sisalId);
    }
}

function onModalTrigger(ev, modalData) {
    let modalId = modalData.modal.data('modal-id');
    if (!modalId) return;

    if (modalId === 'delete-all' && modalData.type === 'accept') {
        $('#designer-desk').empty();
        LoadAndSave.updateURL(null);
        $(document).trigger('ds--removeall')
    }
}

function getProductByEl($el) {
    if (!$el) return null;
    let product = MasterData.products[$el.data('productId')];
    return product || null;
}

function toggleTrigger(name, state = null, htmlAttrs = null) {
    let cls = 'btn_hidden',
        $el = $('.js--trigger-' + name);
    if (Util.isNull(state)) state = !$el.hasClass(cls);
    $el.toggleClass(cls, !state);

    if (htmlAttrs) {
        Object.keys(htmlAttrs).forEach((key) => {
            let val = htmlAttrs[key];
            $el.attr(key, val);
        });
    }
}

function toggleModalTrigger(name, state = null) {
    let cls = 'modal__trigger_open',
        $el = $(`[data-modal-id="${name}"]`);
    if (Util.isNull(state)) state = !$el.hasClass(cls);
    $el.toggleClass(cls, state);
}


// ---------- MAIN ----------

Select.autoDiscover = false;
Tabs.autoDiscover = false;
init();

$(() => {
    Nodes = getNodes();
    MasterData.promise.then(() => {
        renderInventory();
        renderColors();

        setTimeout(() => Tabs._autoDiscover(), 100);
    });

    $(document)
        .on('click', '.js--trigger-rotate', onRotate)
        .on('click', '.js--trigger-sisal', onToggleSisal)
        .on('click', onDeselect)
        .on('modal--trigger', onModalTrigger)
        .on('dd--dragstart', onDragStart)
        .on('dd--dragend', onDragEnd)
});
